export function init() {
  const bannerBottom = document.querySelector('.js-banner-bottom') as HTMLElement | null;
  if (!bannerBottom) return; // Exit if element is not found

  // Set the transition style
  bannerBottom.style.transition = 'bottom 0.5s ease-in-out';

  const scrollThreshold = parseInt(bannerBottom.getAttribute('data-scroll-threshold') || "0", 10);
  const hasSticky = bannerBottom.classList.contains('js-banner-bottom-scroll-sticky-top');
  const scrollTop = document.documentElement.scrollTop;

  if (hasSticky) {
    // If the banner has been shown before or user scrolled past the threshold, keep it visible.
    if (bannerBottom.dataset.shown === "true" || scrollTop > scrollThreshold) {
      bannerBottom.style.bottom = '0';
      bannerBottom.dataset.shown = "true"; // Mark as shown
    } else {
      // Not reached the threshold yet; keep it hidden.
      bannerBottom.style.bottom = '-150px';
    }
  } else {
    // For non-sticky banners, use the normal behavior.
    if (scrollTop > scrollThreshold) {
      bannerBottom.style.bottom = '0';
    } else {
      bannerBottom.style.bottom = '-150px';
    }
  }
}

window.addEventListener('scroll', init);
